import { NgrInputs } from "services/total/types"

interface BuildRowsArgs {
  inputs: NgrInputs
  wager?: number
  win?: number
  freespinWinnings?: number
}

interface RowConfig {
  label: string
  value: number
  children?: RowConfig[]
  note?: string
  struckValue?: number
}

export function buildNgrRows({ inputs, wager = 0, win = 0 }: BuildRowsArgs): RowConfig[] {
  const netBonus = (inputs.bonus ?? 0) - (inputs.cancelledBonusAmount ?? 0)
  const rawGgrFee7 = (inputs.ggr ?? 0) * 0.07
  const ggrFee7 = Math.max(rawGgrFee7, 0)

  return [
    {
      label: "GGR (Wager - Win)",
      value: inputs.ggr ?? 0,
      children: [
        { label: "Wager", value: wager },
        { label: "Win", value: win }
      ]
    },
    {
      label: "Net bonus cost (Bonus - Cancelled)",
      value: netBonus,
      children: [
        { label: "Bonus", value: inputs.bonus ?? 0 },
        { label: "Cancelled bonus", value: inputs.cancelledBonusAmount ?? 0 }
      ]
    },
    {
      label: "GGR fee (7%)",
      value: ggrFee7,
      struckValue: rawGgrFee7 < 0 ? rawGgrFee7 : undefined,
      note: "limited at 0"
    },
    {
      label: "Positive GGR fees",
      value: inputs.positiveGgrFees ?? 0
    },
    {
      label: "Deposits",
      value: inputs.deposit ?? 0
    },
    {
      label: "Deposit fee (8.5%)",
      value: (inputs.deposit ?? 0) * 0.085
    },
    {
      label: "Withdrawals",
      value: inputs.withdrawal ?? 0
    },
    {
      label: "Withdrawal fee (4%)",
      value: (inputs.withdrawal ?? 0) * 0.04
    }
  ]
}
